import {
  CONFIG,
  PROFILES,
  ROLES,
  UNIT,
  SEGMENTATIONS,
  CONSTRUCTION_STAGE,
} from './constants';
import logTrace from './logTraceEnums';

const {
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
  FINANCIAL_PROFILE,
  ADMIN_FINANCIAL_PROFILE,
} = PROFILES;

const { CLIENT_ROLE, SYNDIC_ROLE } = ROLES;

const supportViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const documentViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const newsViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const bannerViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const bulletinViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const clientViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const clientUpdateProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const enterpriseViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
];
const financialViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
  FINANCIAL_PROFILE,
  ADMIN_FINANCIAL_PROFILE,
];
const clientViewRoles = [CLIENT_ROLE];
const syndicViewRoles = [SYNDIC_ROLE];

export const snackbarColors = {
  success: 'green',
  info: 'blue',
  warning: 'orange',
  error: 'red',
};

export const menuModules = {
  ENTERPRISE: 'enterprise',
  SYNDIC: 'syndic',
  FINANCIAL: 'financial',
  DOCUMENT: 'document',
  BULLETIN: 'bulletin',
  NEWS: 'news',
  SUPPORT: 'support',
  PROFILE: 'profile',
};

export default {
  clientViewRoles,
  syndicViewRoles,
  supportViewProfiles,
  documentViewProfiles,
  bannerViewProfiles,
  bulletinViewProfiles,
  clientViewProfiles,
  clientUpdateProfiles,
  enterpriseViewProfiles,

  logTraceActions: logTrace.actions,
  logTraceActionRoutes: logTrace.routes,

  underConstructionStages: [
    'Construção',
    'Em Atraso',
    'Embargada',
    'Pré-Entrega',
  ],

  constuctionStages: {
    'Pré-Lançamento': CONSTRUCTION_STAGE.LAUNCH,
    Lançamento: CONSTRUCTION_STAGE.LAUNCH,
    Construção: CONSTRUCTION_STAGE.IN_CONSTRUCTION,
    'Em Atraso': CONSTRUCTION_STAGE.IN_CONSTRUCTION,
    'Pré-Entrega': CONSTRUCTION_STAGE.IN_CONSTRUCTION,
    'Entregue com Pendência': CONSTRUCTION_STAGE.DELIVERED,
    'Entregue sem Pendência': CONSTRUCTION_STAGE.DELIVERED,
    Embargada: CONSTRUCTION_STAGE.IN_CONSTRUCTION,
    Repasse: CONSTRUCTION_STAGE.LAUNCH,
    Cancelado: CONSTRUCTION_STAGE.LAUNCH,
  },

  constuctionStageSegmentation: {
    [CONSTRUCTION_STAGE.LAUNCH]: SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE,
    [CONSTRUCTION_STAGE.IN_CONSTRUCTION]:
      SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
    [CONSTRUCTION_STAGE.DELIVERED]: SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
  },

  accessTypes: {
    continuedSession: 'Sessão Continuada',
    login: 'Login',
    repeatedEmail: 'Email Repetido',
    admin: 'Admin',
  },

  notificationsProfiles: [
    ADMIN_PROFILE,
    ADMIN_BEXS_PROFILE,
    ADMIN_HR_PROFILE,
    HR_PROFILE,
  ],

  locationApiBrazilId: 31,

  maxUploadFileSize: 15,

  snackbarColors,

  responses: {
    error: 'Ocorreu um erro, por favor tente novamente mais tarde.',
    connectionError: 'Verifique sua conexão com a internet e tente novamente',
    invalidLogin: {
      username: 'Número de CPF ou CNPJ inválido',
      password: 'Senha inválida',
    },
    invalidUsername: {
      username: 'Número de CPF ou CNPJ inválido',
      document: 'Número de CPF ou CNPJ inválido',
    },
    invalidPassword: {
      password: 'Senha inválida',
    },
    oldPasswordNotMatch: {
      oldPassword: 'A senha atual está incorreta',
    },
    invalidCode: {
      temporaryPassword: 'Senha temporária inválida',
    },
    codeExpire: {
      temporaryPassword:
        'Sua senha temporária expirou. Clique em "Reenviar senha" para receber uma nova senha temporária.',
    },
    userExists: {
      document: 'Seu usuário já existe, tente acessar pelo login.',
    },
    userAlreadyChangedItsPassword: {
      passwordAlreadyChanged:
        'Você já realizou a troca da sua senha. Clique em “Ir para Login” para fazer seu acesso.',
    },
    userDoesNotExistForResetPassword: {
      username:
        'Não encontramos o CPF informado. Confira os dados e preencha novamente. Se o erro persistir, entre em contato com a Central de Relacionamento com Cliente.',
    },
    emailRepeated: 'Outro usuário possui esse email',
    incorrectCredentials: {
      password: 'Credenciais incorretas',
    },
    userBlocked: 'Acesso temporariamente bloqueado. Tente novamente mais tarde',
    invalidLogin:
      'Credenciais incorretas. Após 5 tentativas com erro, o acesso será bloqueado por 1 hora.',
  },

  fileCategory: {
    BANNER_IMAGE: 'banner-image',
    BULLETIN_FILE: 'bulletin-file',
    TICKET_ATTACHMENT: 'ticket-attachment',
    GENERAL_DOCUMENT: 'general-document-file',
    LEGAL_DOCUMENT: 'legal-document-file',
    OWNER_DOCUMENT: 'owner-document-file',
    TEXT_EDITOR_IMAGES: 'text-editor-image',
  },

  financialModules: {
    FINANCIAL_POSITION: 'financialPosition',
    LATE_SLIPS: 'late',
    TO_EXPIRE_SLIPS: 'toExpire',
    ANTICIPATION_SLIPS: 'anticipation',
    IR: 'incomeReport',
  },

  contractValues: {
    buyAndSell: 'PCV',
    personalization: 'Personalização',
    cession: 'Cessão',
    cessionPersonalization: 'Cessão-Personalização',
    detached: 'Avulso',
    cessionDetached: 'Cessão-Avulso',
    indirect: 'Indireto',
  },
  contractStatusValues: {
    active: 'Ativo',
    settled: 'Quitado',
    cession: 'Cessão',
    indirectActive: 'Indireto Ativo',
    canceled: 'Cancelado',
  },

  latePaymentSlipTooltip:
    'De acordo com as normas da FEBRABAN (Federação Brasileira de Bancos), todo e qualquer boleto deve estar cadastrado na base de dados do sistema para serem pagos na rede bancária. Esclarecemos que esse registro pode levar até 01 (um) dia útil. Desta forma, caso não consiga efetuar o pagamento no dia de emissão do boleto, orientamos que tente realizar o pagamento no próximo dia útil ou na data de seu vencimento.',

  financialPositionToExpireTooltip:
    'Os valores constantes na posição financeira, estão projetados para o último dia do mês vigente. Para consultar o valor para pagamento no dia do vencimento, acesse o seu boleto.',

  legalDocuments: {
    1: {
      shortName: 'AVCB',
      name: 'Auto de vistoria do corpo de bombeiros',
      responsibleBody: 'Corpo de Bombeiros',
      description: 'Auto de vistoria do Corpo de Bombeiros.',
    },
    2: {
      shortName: 'Habite-se',
      name: 'Auto conclusão da obra',
      responsibleBody: 'Prefeitura Municipal',
      description: 'Auto de conclusão de obra.',
    },
    3: {
      shortName: 'CND de Obras',
      name: 'Certidão negativa de débitos no INSS',
      responsibleBody: 'Receita Federal',
      description: 'Certidão negativa de débito no INSS.',
    },
    4: {
      shortName: 'Instituição e especificação do condomínio',
      name: 'Averbação da construção na matrícula mãe do imóvel',
      responsibleBody: 'Cartório de Registro de Imóveis',
      description: 'Averbação da construção da matrícula-mãe do imóvel.',
    },
    5: {
      shortName: 'Assembleia de instalação do condomínio',
      name: 'Assembleia de instalação do condomínio (AGI)',
      responsibleBody: 'Não Há',
      description:
        'A Assembleia Geral de Instalação de Condomínio "AGI" é o evento através do qual o Condomínio passa a existir de fato, realizado após a averbação da construção.',
    },
  },

  eventTitles: {
    1: 'Assembleia Geral de Instalação - AGI',
    2: 'Assembleia de Patrimônio de Afetação',
    3: 'Visita de Patrimônio de Afetação',
    4: 'Agende sua chave',
    5: 'Agendamento de Vistoria de Obra',
  },

  paymentSlipWaitingState: {
    icon: 'payment',
    title: 'pages.paymentSlip.waitingState.title',
    firstLine: 'pages.paymentSlip.waitingState.firstLine',
    secondLine: 'pages.paymentSlip.waitingState.secondLine',
  },

  paymentSlipError: {
    icon: 'payment',
    title: 'pages.paymentSlip.error.title',
    firstLine: 'pages.paymentSlip.error.firstLine',
    link: 'pages.paymentSlip.error.link',
  },

  legalDocumentsStatus: {
    1: 'Concluído',
    2: 'Em andamento',
    3: 'Não iniciado',
  },

  legalDocumentsStatusValues: {
    done: 1,
    inProgress: 2,
    notStarted: 3,
  },

  ownerDocumentsStatus: {
    1: 'Concluído',
    2: 'Em andamento',
    3: 'Não iniciado',
  },

  ownerDocumentsStatusValues: {
    done: 1,
    inProgress: 2,
    notStarted: 3,
  },

  documentsType: {
    legal: 1,
    general: 2,
    unit: 3,
    owner: 4,
  },

  paymentSlipRequestButtonText: 'Gerar boleto',

  paymentSlipRequestSteps: {
    stepOneTitle: 'Selecione as parcelas',
    stepTwoTitle: 'Gerando boleto',
    stepTreeTitle: 'Boleto gerado',
  },

  changeRepeatedEmailSteps: [
    {
      description: 'Atualização',
    },
    {
      description: 'Confirmação',
    },
    {
      description: 'Sucesso',
    },
  ],

  ticketStatus: {
    inAnalysis: {
      color: '#3dcdce',
      title: 'Em análise',
      value: 'inAnalysis',
      icon: 'asterisk',
      allowInteraction: true,
    },
    directed: {
      value: 'directed',
      color: '#3db347',
      title: 'Em andamento',
      icon: 'play',
      allowInteraction: true,
    },
    waitingReply: {
      color: '#ffc271',
      title: 'Aguardando sua resposta',
      value: 'waitingReply',
      icon: 'pause',
      allowInteraction: true,
    },
    inProgress: {
      color: '#3db347',
      title: 'Em andamento',
      value: 'inProgress',
      icon: 'play',
      allowInteraction: true,
    },
    done: {
      color: '#bcbcbc',
      title: 'Finalizado',
      value: 'done',
      icon: 'msg-sent',
      allowInteraction: false,
    },
  },

  stateCodes: [
    {
      value: 1,
      text: 'AC',
    },
    {
      value: 2,
      text: 'AL',
    },
    {
      value: 3,
      text: 'AP',
    },
    {
      value: 4,
      text: 'AM',
    },
    {
      value: 5,
      text: 'BA',
    },
    {
      value: 6,
      text: 'CE',
    },
    {
      value: 7,
      text: 'DF',
    },
    {
      value: 8,
      text: 'ES',
    },
    {
      value: 9,
      text: 'GO',
    },
    {
      value: 10,
      text: 'MA',
    },
    {
      value: 11,
      text: 'MT',
    },
    {
      value: 12,
      text: 'MS',
    },
    {
      value: 13,
      text: 'MG',
    },
    {
      value: 14,
      text: 'PA',
    },
    {
      value: 15,
      text: 'PB',
    },
    {
      value: 16,
      text: 'PR',
    },
    {
      value: 17,
      text: 'PE',
    },
    {
      value: 18,
      text: 'PI',
    },
    {
      value: 19,
      text: 'RJ',
    },
    {
      value: 20,
      text: 'RN',
    },
    {
      value: 21,
      text: 'RS',
    },
    {
      value: 22,
      text: 'RO',
    },
    {
      value: 23,
      text: 'RR',
    },
    {
      value: 24,
      text: 'SC',
    },
    {
      value: 25,
      text: 'SP',
    },
    {
      value: 26,
      text: 'SE',
    },
    {
      value: 27,
      text: 'TO',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/utils/enums.js